<div class="btn-group btn-group--paybee btn-group-toggle btn-group-toggle--paybee">
  <label
    [ngClass]="{'active': value === 0 }"
    class="btn btn--paybee btn--event-status d-flex flex-column"
  >
    <input name="status" type="radio" (click)="writeValue(0)">
    <app-icon-status-lobby class="status__icon"></app-icon-status-lobby>
    <span class="status__text font-weight-bold">Lobby</span>
  </label>
  <label
    [ngClass]="{'active': value === 1 }"
    class="btn btn--paybee btn--event-status d-flex flex-column"
  >
    <input name="status" type="radio" (click)="writeValue(1)">
    <app-icon-status-start class="status__icon"></app-icon-status-start>
    <span class="status__text font-weight-bold">Start</span>
  </label>
  <label
    [ngClass]="{'active': value === 2 }"
    class="btn btn--paybee btn--event-status d-flex flex-column"
  >
    <input name="status" type="radio" (click)="writeValue(2)">
    <app-icon-status-stop class="status__icon"></app-icon-status-stop>
    <span class="status__text font-weight-bold">Stop</span>
  </label>
</div>